import { z } from "zod/v4";

import { SPOT_ARRIVAL_REASON_CODES } from "./spot-arrival";

/**
 * Every code the system itself writes to `entry_event.reason`:
 * `deriveScanVerdict` (packages/api/src/lib/scan.ts), `scan.validate`'s
 * `not_found`, `blocked` (sent by both gate clients — web poste and the
 * gardien app — when the gardien refuses a blacklisted visitor, stored as-is
 * by `scan.record`), and the arrivée-imprévue codes `spot-arrival.close`
 * stamps. Any other string is free text passed through by a client, which the
 * Activité filter groups as `other`. A new code must be added here, or it
 * lands in « Autre motif » (a web test pins REASON_LABELS against this list).
 */
export const ENTRY_REASON_CODES = [
  "revoked",
  "not_yet_valid",
  "expired",
  "off_schedule",
  "already_used",
  "pending",
  "rejected",
  "incomplete",
  "not_found",
  "blocked",
  ...SPOT_ARRIVAL_REASON_CODES,
] as const;
export type EntryReasonCode = (typeof ENTRY_REASON_CODES)[number];

export const ENTRY_REASON_FILTERS = [...ENTRY_REASON_CODES, "other"] as const;
export type EntryReasonFilter = (typeof ENTRY_REASON_FILTERS)[number];
export const entryReasonFilterSchema = z.enum(ENTRY_REASON_FILTERS);
